<nb-card [class.active]="plan?.active" [nbSpinner]="isWaiting">
  <nb-card-header>
    <div class="d-flex align-items-center">
      <nb-icon icon="grip-vertical" pack="fas" *ngIf="programMode"></nb-icon>
      <nb-badge [text]="plan?.zOrder" status="info" *ngIf="programMode" class="position-relative mr-2"></nb-badge>
      <div class="d-inline">{{ plan?.name }}</div>

    </div>
    <div class="float-right">
      <div style="display: flex;flex-direction: column;">

        <button *ngIf="programMode" nbButton status="basic" ghost type="button" shape="round" (click)="onUp()" style="padding: 2px !important;">
          <nb-icon icon="arrow-ios-upward-outline"></nb-icon>
        </button>
        <button *ngIf="programMode" nbButton status="basic" ghost type="button" shape="round" (click)="onDown()"style="padding: 2px !important;">
          <nb-icon icon="arrow-ios-downward-outline"></nb-icon>
        </button>


      </div>

      <button nbButton class="btn-circle btn-xl btn-main" type="submit" (click)="onSend()" *ngIf="!programMode">
        <i class="fas fa-mobile-alt"></i>&nbsp;Send Plan
      </button>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="row plan-item">
      <div class="info col-md-5">
        <!-- Duration -->
        <ul class="basic_list_informations" *ngIf="programMode">
          <li class="d-flex align-items-center">
            <label class="DimmedLabel">
              <ng-container i18n="@@Duration">Duration</ng-container>:
            </label>
          </li>
          <li class="d-flex align-items-center">
            <nb-select size="small" [disabled]="isWaiting" [selected]="plan?.duration"
              (selectedChange)="onDurationChanged($event)" #durationSelect>
              <nb-option *ngFor="let option of durationOptions" [value]="option.value">
                {{ option.label }}
              </nb-option>
            </nb-select>
          </li>
        </ul>

        <!-- Days -->
        <ul class="basic_list_informations">
          <li>
            <label class="DimmedLabel">
              <ng-container i18n="@@Days">Days</ng-container>:
            </label>
          </li>
          <li>{{ plan?.days?.length }}&nbsp;{{ assignedWeekDays }}</li>
        </ul>

        <!-- Created Date 
        <ul class="basic_list_informations">
          <li>
            <label class="DimmedLabel">
              <ng-container i18n="@@CreatedOn">Created</ng-container>:
            </label>
          </li>
          <li>{{ plan?.createdDate | date }}</li>
        </ul>-->

        <!-- Start Date -->
        <ul class="basic_list_informations" *ngIf="programMode && (!isProgramTemplate)">
          <li>
            <label class="DimmedLabel">
              <ng-container i18n="@@StartDate">Start</ng-container>:
            </label>
          </li>
          <li>{{ startDate | date }}</li>
        </ul>

        <!-- End Date -->
        <ul class="basic_list_informations" *ngIf="programMode && (!isProgramTemplate)">
          <li>
            <label class="DimmedLabel">
              <ng-container i18n="@@End">End</ng-container>:
            </label>
          </li>
          <li>{{ endDate | date }}</li>
        </ul>

        <!-- Active -->
        <ul class="basic_list_informations" *ngIf="!programMode">
          <li>
            <label class="DimmedLabel">
              <ng-container i18n="@@Active">Active</ng-container>:
            </label>
          </li>
          <li>
            <nb-toggle [(ngModel)]="plan.active" (change)="onActiveChanged($event)"></nb-toggle>
          </li>
        </ul>
      </div>

      <div class="actions col-md-7">
        <ul>
          <li>
            <a href="javascript:void(0);" i18n-title="@@Edit" title="Edit" class="action animation-fill"
              (click)="onEdit()">
              <nb-icon icon="modify-pencil-outline" i18n-title="@@Edit" title="Edit" pack="custom"></nb-icon>
              <div class="custom-tooltip">
                Edit
              </div>
            </a>
          </li>

          <li *ngIf="!nativeAppService.isFromApp() && patientGuid && !isProgramTemplate">
            <a routerLink="/PatientView/Patient/{{ patientGuid }}/{{
                isFitnessPlan ? 'Workout' : 'Meal'
              }}/{{ plan?.id }}" i18n-title="@@PatientView" title="Patient View" target="_blank"
              class="action animation-fill">
              <nb-icon icon="person-outline" i18n-title="@@PatientView" title="Patient View"></nb-icon>
              <div class="custom-tooltip">
                Client View
              </div>
            </a>
          </li>

          <li *ngIf="nativeAppService.isFromApp() && patientGuid && !isProgramTemplate">
            <a href="javascript:void(0);" (click)="onClientLinkClick()" i18n-title="@@PatientView" title="Patient View"
              class="action animation-fill">
              <nb-icon icon="person-outline" i18n-title="@@PatientView" title="Patient View"></nb-icon>
              <div class="custom-tooltip">
                Client View
              </div>
            </a>
          </li>

          <li *ngIf="!isProgramTemplate">
            <a href="javascript:void(0);" i18n-title="@@CreateTemplate" title="Create Template"
              class="action animation-fill" (click)="onSaveAsTemplate()">
              <nb-icon icon="archive-box-outline" i18n-title="@@CreateTemplate" title="Create Template" pack="custom">
              </nb-icon>
              <div class="custom-tooltip">
                Save As Template
              </div>
            </a>
          </li>

          <li>
            <a href="javascript:void(0);" i18n-title="@@Duplicate" title="Duplicate" class="action animation-fill"
              (click)="onDuplicate()">
              <nb-icon icon="copy-outline" i18n-title="@@Duplicate" title="Duplicate" pack="eva"></nb-icon>
              <div class="custom-tooltip">
                Dupilcate
              </div>
            </a>
          </li>

          <li>
            <a href="javascript:void(0);" i18n-title="@@Delete" title="Delete" class="action animation-fill"
              (click)="onDelete()">
              <nb-icon icon="trash-2-outline" i18n-title="@@Delete" title="Delete"></nb-icon>
              <div class="custom-tooltip">
                Remove
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <span class="custom-created-date" style="float: right; font-size: xx-small;  color: gray;">Created {{
      plan?.createdDate | date }}</span>
  </nb-card-body>
</nb-card>

<ng-template #datepickerDlg let-data let-ref="dialogRef">
  <nb-card class="datepickerDlg">
    <nb-card-header>
      <span class="title">Select Specified Date</span>
    </nb-card-header>

    <nb-card-body>
      <nb-calendar [(date)]="dateInCalendar" [min]="minDateInCalendar"></nb-calendar>
    </nb-card-body>

    <nb-card-footer>
      <button nbButton [disabled]="!!!dateInCalendar" class="m-1" (click)="onDateSelected(ref)">
        <nb-icon icon="checkmark-outline"></nb-icon>
        <span>Select</span>
      </button>
      <button nbButton class="m-1" (click)="onDateCanceled(ref)">
        <nb-icon icon="close-outline"></nb-icon>
        <span>Cancel</span>
      </button>
    </nb-card-footer>
  </nb-card>
</ng-template>